module.exports = __webpack_public_path__ + "img/title_bg.da51c5cd.png";